import { useOutletContext } from "react-router-dom";

export interface HomeOutletContext {
  onSidebarToggle: () => void;
  isSidebarExpandable: boolean;
}

export function useHomeOutletContext(): HomeOutletContext {
  return useOutletContext<HomeOutletContext>();
}
